module.exports = __webpack_public_path__ + "static/img/5240.a153ced.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/5240.svg
// module id = fZbH
// module chunks = 7